<template>
  <div class="content">
    <div class="content-wrapper">
      <router-view/>

    </div>

  </div>
  <footer>
    <a href="https://mr-pixel.de/impressum/" target="_blank">Impressum</a> |
    <a href="https://mr-pixel.de/datenschutz/" target="_blank">Datenschutz</a>
  </footer>
</template>



<style>
@font-face {
  font-family: 'Alexandria';
  src: url('../public/Alexandria-VariableFont_wght.ttf') format('truetype');
  font-weight: 100 900;
  font-style: normal;
}

#app {
  font-family: Alexandria, Arial, sans-serif;
  text-align: left;
  color: #2c3e50;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

footer {
  display: block;
  margin-top: auto;
  position: relative;
  text-align: center;
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
}

footer a {
  color: #2c3e50;
  text-decoration: none;
}

footer a:hover {
  text-decoration: underline;
}

.content {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;

}

.content-wrapper {
  display: flex;
  min-width: auto;
  box-sizing: border-box;
}

</style>

<script setup lang="ts">
</script>